import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import { Table, TableColumnsType } from 'antd';
import Loader from '../../../components/Loader';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import Button from '../../../components/Button';
import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import { IGetTypes, IType } from '../../../models/evaluation.model';
import useLoader from '../../../hooks/useLoader';
import { getTypes } from '../../../api/evaluation.api';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import qs from 'qs';
import config from '../../../lib/config';
import Pagination from '../../../components/Pagination';

const ProgramConvert: FC = () => {
  const { writeAuthYn } = useAuth();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // GR0002 = 평가 입력유형
  const GR0002 = commonCodes.find(item => item.commonCode === 'GR0002')?.detailCode;
  const { data: res, isLoading, error, execute } = useAxios<IGetTypes>();
  useLoader(isLoading, [error]);

  useEffect(() => {
    execute(getTypes());
  }, []);

  const columns: TableColumnsType<IType> = [
    {
      title: t('program.convert.column1'),
      dataIndex: 'typeName',
      align: 'center',
      render: (value, record) => i18n.language === 'ko' ? value : record.typeNameEn,
    },
    {
      title: t('program.convert.column2'),
      dataIndex: 'inputTypeCode',
      align: 'center',
      render: value => {
        const inputType = GR0002?.find(item => item.detailCode === value);
        return inputType ? (i18n.language === 'ko' ? inputType.korName : inputType.engName) : value;
      }
    },
    {
      title: '',
      dataIndex: 'typeCode',
      align: 'center',
      render: (value, record) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className='btn-basic mint small'
            onClickCapture={e => {
              e.stopPropagation();
              history.push(`/program/convert/${value}/table?name=${i18n.language === 'ko'?record.typeName:record.typeNameEn}`);
            }}
            text={t('common.button.detail')}
            disabled={record.inputTypeCode === 'PC'}
          />
        </div>

      )
    },
  ];

  return (
    <>
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={t('program.convert.title1')}
        iconFile="icon-program-big.svg"
        onlyTitle
      />
      <div className="col-frame">
        <div className="comm-bx__between">
          <div className="comm-sch_result" />
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/program/convert/create')}
              text={t('program.award.button2')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
        <div className="comm-table__area">
          <Table
            columns={columns}
            dataSource={res?.data}
            pagination={{ pageSize: 99999 }}
            onRow={record => ({
              onClick: () => {
                history.push(`/program/convert/${record.typeCode}/edit`);
              },
            })}
            rowClassName="pointer"
          />
        </div>
        <div className="comm-bx__space">
          <div className="comm-btn__area right">
            <Button
              className="btn-basic pink"
              onClick={() => history.push('/program/convert/create')}
              text={t('program.award.button2')}
              writeAuthYn={writeAuthYn}
            />
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default ProgramConvert;